import { render, staticRenderFns } from "./imgProperty.vue?vue&type=template&id=396818e7"
import script from "./imgProperty.vue?vue&type=script&lang=js"
export * from "./imgProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports